import { render, staticRenderFns } from "./Areas.vue?vue&type=template&id=3ba4b391&"
import script from "./Areas.vue?vue&type=script&lang=ts&"
export * from "./Areas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports